<template>
    <div>
        <div v-if="vehicles.data">
            <div class="cms-content-slice-stock-list__filters">

                <button v-on:click.prevent="openMobileFilters = !openMobileFilters" :class="{ 'cms-content-our-range-filter__mobile-filter-btn cms-content-our-range-filter__button btn btn--full-width': true, 'cms-content-our-range-filter__button--active': openMobileFilters }">
                    Filter
                </button>
                <div :class="{
                    'cms-content-our-range-filter__group': true,
                    'cms-content-our-range-filter__group--open': openMobileFilters,
                }">
                    <SelectDropdown option-key="brands" id="brandSelect">
                        Brand
                    </SelectDropdown>
                    <SelectDropdown option-key="models" id="modelSelect">
                        Model
                    </SelectDropdown>
                    <SelectDropdown option-key="colours" id="colourSelect">
                        Colour
                    </SelectDropdown>
                    <!-- <MinMaxSliderDropdown v-if="initialized && showMinMaxSlider" id="budgetDropRange" min-key="minPrice" max-key="maxPrice" :step="500" :financial="true" >
                        Price
                    </MinMaxSliderDropdown> -->
                </div>
                <div class="cms-content-slice-stock-list__count">
                    <span>Showing <span>{{ vehiclesCount }} </span> of <span>{{ vehicles.total }}</span> cars found</span>
                </div>
            </div>
            <div class="cms-content-slice-stock-list__list rd-card rd-card--border-top">
                <div class="cms-content-slice-stock-list__list--scroll">
                    <div class="cms-content-slice-stock-list__titles">
                        <div class="cms-content-slice-stock-list__title"></div>
                        <div class="cms-content-slice-stock-list__title">Brand</div>
                        <div class="cms-content-slice-stock-list__title">Model</div>
                        <div class="cms-content-slice-stock-list__title">Colour</div>
                        <div class="cms-content-slice-stock-list__title">Customer Saving</div>
                        <div class="cms-content-slice-stock-list__title">Price</div>
                        <div class="cms-content-slice-stock-list__title"></div>
                    </div>

                    <stock-list-row v-for="vehicle in vehicles.data" :key="vehicle.id" :vehicle="vehicle" />
                </div>

                <div v-if="showAddMoreButton" class="cms-content-slice-stock-list__load-more">
                    <button v-on:click="loadMoreResults" type="button" class="btn btn--blue-inverted">
                        Load More
                    </button>
                </div>
            </div>
        </div>
        <div v-else>
            <LoadingSpinner/>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import SelectDropdown from './SelectDropdown.vue'
import StockListRow from './StockListRow.vue'
import MinMaxSliderDropdown from './MinMaxSliderDropdown.vue'
import LoadingSpinner from '../../../used-vue/components/Buy-Online/LoadingSpinner.vue'
// import { customEvent } from '../../../modules/tracking/AnalyticsEvents'

export default {
    components: {
        SelectDropdown,
        MinMaxSliderDropdown,
        LoadingSpinner,
        StockListRow,
    },
    computed: {
        ...mapState([
            'vehicles',
            'loadingVehicles',
            'initialized',
            'availableOptions',
        ]),
        showAddMoreButton() {
            return this.vehicles.current_page < this.vehicles.last_page && !this.loadingVehicles
        },
        vehiclesCount() {
            return this.vehicles.data.length
        },
    },
    data() {
        return {
            openMobileFilters: false,
            showMinMaxSlider: true,
        }
    },
    methods: {
        resetFilters() {
            this.showMinMaxSlider = false
            this.$store.commit('updateOptions', {
                brand: [],
                colours: [],
                models: [],
                // minPrice: this.availableOptions.minPrice,
                // maxPrice: this.availableOptions.maxPrice,
            })
            this.$store.dispatch('getVehiclesAndOptions')
            this.$nextTick(() => {
                this.showMinMaxSlider = true
            })
        },
        loadMoreResults() {
            this.$store.dispatch('getMoreVehicles', {
                page: this.vehicles.current_page + 1,
            })
        },
    },
    created() {
        this.$store.dispatch('getVehiclesAndOptions')
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/cms-content-slices/components/stock-list/StockList.vue